import { all, takeEvery, put, call, select } from 'redux-saga/effects'
import { notification, Modal } from 'antd'
import { history } from 'index'
import workOrderActions from 'redux/workOrders/actions'
import actions from './actions'
import { SAVE_200_MSG, SAVE_200_DESC, DEL_200_MSG, DEL_200_DESC } from '../../constants'
import {
  list,
  find,
  save,
  remove,
  create,
  copy,
  getCostView,
  listForApprovement,
  sendToApprovement,
  findForPreview,
  approveProposal,
  rejectProposal,
  cancelProposal,
} from '../../services/proposal'

function* fetchProposalsRefresh() {
  const fe = JSON.parse(localStorage.getItem('proposalsFilter'))
  if (fe == null) {
    fe.size = 10
    fe.index = 0
  }
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(list, fe.size, fe.index)
  yield put({
    type: actions.LIST_PROPOSAL,
    result,
  })
}

function* fetchProposals({
  size,
  index,
  orderBy,
  orderNumber,
  proposalNumber,
  beginDate,
  endDate,
  status,
}) {
  console.log(
    'fetchProposals',
    size,
    index,
    orderBy,
    orderNumber,
    proposalNumber,
    beginDate,
    endDate,
    status,
  )
  size = size || localStorage.getItem('pageSize') || 15

  const savedFilters = localStorage.getItem('proposalsFilter')

  if (savedFilters) {
    const parsedFilters = JSON.parse(savedFilters)

    orderNumber = orderNumber || parsedFilters.orderNumber || null
    proposalNumber = proposalNumber || parsedFilters.proposalNumber || null
    beginDate = beginDate || parsedFilters.beginDate || null
    endDate = endDate || parsedFilters.endDate || null
    status = status || parsedFilters.status || null
  }

  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(
    list,
    size,
    index,
    orderBy,
    orderNumber,
    proposalNumber,
    beginDate,
    endDate,
    status,
  )
  yield put({
    type: actions.LIST_PROPOSAL,
    result,
  })
}

function* fetchProposalsForApprovement({
  size,
  index,
  orderBy,
  orderNumber,
  proposalNumber,
  beginDate,
  endDate,
  status,
}) {
  console.log(
    'fetchProposalsForApprovement',
    size,
    index,
    orderBy,
    orderNumber,
    proposalNumber,
    beginDate,
    endDate,
    status,
  )
  size = size || localStorage.getItem('pageSize') || 15

  const savedFilters = localStorage.getItem('fetchProposalsForApprovementFilter')

  if (savedFilters) {
    const parsedFilters = JSON.parse(savedFilters)

    orderNumber = orderNumber || parsedFilters.orderNumber || null
    proposalNumber = proposalNumber || parsedFilters.proposalNumber || null
    beginDate = beginDate || parsedFilters.beginDate || null
    endDate = endDate || parsedFilters.endDate || null
    status = status || parsedFilters.status || null
  }

  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(
    listForApprovement,
    size,
    index,
    orderBy,
    orderNumber,
    proposalNumber,
    beginDate,
    endDate,
    status,
  )
  yield put({
    type: actions.LIST_PROPOSAL,
    result,
  })
}

function* createProposal() {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(create)
  yield put({
    type: actions.CREATE_PROPOSAL_RECIEVED,
    result,
  })
}

function* copyProposal({ id }) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(copy, id)

  console.log('Proposal Copy Result', result)

  yield put({
    type: actions.COPY_PROPOSAL_RECIEVED,
    result,
  })
}

function* copyProposalReset() {
  yield put({
    type: actions.COPY_PROPOSAL_RESET_RECIEVED,
  })
}

function* resetPRoposal() {
  yield put({
    type: actions.RESET_PROPOSAL_RECIEVED,
  })
}

function* createResetProposal() {
  yield put({
    type: actions.CREATE_RESET_PROPOSAL_RECIEVED,
  })
}

function* fetchCostView({ id }) {
  if (id) {
    yield put({
      type: actions.REQUESTING,
    })
    const result = yield call(getCostView, id)
    yield put({
      type: actions.FETCH_COST_VIEW_RECIEVED,
      result,
    })
  }
}

// A proposal that cannot be loaded (deleted - e.g. reached with Back right after deleting
// it - or unknown): the server answers with a readable reason, which the request helper
// already shows. Leave that page for its list instead of rendering a blank page. Only
// when the user is ON that proposal's page - the work order page also loads its proposal.
function* leaveMissingProposal(pagePrefix, listPath) {
  // Ends the loading state without triggering a re-fetch (Refresh_Recieved would).
  yield put({ type: actions.Refresh_reset_Recieved })
  if (window.location.pathname.startsWith(pagePrefix)) {
    history.replace(listPath)
  }
}

function* fetchProposalEdit({ id }) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(find, id)
  if (!result) {
    yield* leaveMissingProposal('/proposals/', '/proposals')
    return
  }
  yield put({
    type: actions.EDIT_PROPOSAL,
    result,
  })
  yield put({
    type: 'Proposal/FETCH_COST_VIEW',
  })
}

function* fetchProposalEditForPreview({ id }) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(findForPreview, id)
  if (!result) {
    yield* leaveMissingProposal('/proposalApprovement/', '/proposalApprovementList')
    return
  }
  yield put({
    type: actions.EDIT_PROPOSAL,
    result,
  })
  yield put({
    type: 'Proposal/FETCH_COST_VIEW',
  })
}

function* fetchProposalSave(values) {
  yield put({
    type: actions.REQUESTING,
  })
  const saveResult = yield call(save, values)
  // A refused save (status 0 = error, e.g. a number that already exists or a link to
  // another project) comes back with its reason: show it and stay on the stored
  // record instead of announcing a success.
  if (!saveResult || saveResult.status === 0) {
    if (saveResult && saveResult.message) {
      notification.error({ message: 'Not saved', description: saveResult.message, duration: 0 })
    }
    const proposalID = (saveResult && saveResult.value) || (values.values && values.values.proposalID)
    if (proposalID) {
      const current = yield call(find, proposalID)
      yield put({ type: actions.EDIT_PROPOSAL, result: current })
    } else {
      yield put({ type: actions.Refresh_reset_Recieved })
    }
    return
  }
  notification.success({ message: SAVE_200_MSG, description: SAVE_200_DESC })
  console.log('Proposal Save Result', saveResult)
  const result = yield call(find, saveResult.value)
  yield put({
    type: actions.EDIT_PROPOSAL,
    result,
  })
  yield put({
    type: actions.FETCH_COST_VIEW,
  })
}

function* fetchProposalDelete(values) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(remove, values)
  // The backend refuses with a plain-text reason (proposal already sent /
  // approved / rejected ...): show it and stay on the page.
  if (typeof result === 'string' && result.trim() !== '') {
    Modal.error({ title: 'Delete', content: result })
    yield put({ type: actions.Refresh_Recieved })
    return
  }
  if (result !== null) {
    notification.success({ message: DEL_200_MSG, description: DEL_200_DESC })
  }
  yield put({
    type: actions.RE_FETCH_PROPOSALS,
  })

  // Back to where the proposal belongs: its work order, else the proposal list.
  // replace, not push: the deleted proposal's page must not stay in the Back history -
  // going Back to it showed "Sequence contains no elements" on a blank page.
  const { workOrderID } = values.values || {}
  if (workOrderID) {
    // The cached work order still names the deleted proposal; its page would load it
    // once more before the fresh work order arrives.
    const workOrder = yield select(state => state.workOrders.editing)
    if (workOrder && workOrder.proposalID === values.values.DeleteID) {
      yield put({
        type: workOrderActions.EDIT_WORKORDER,
        result: { ...workOrder, proposalID: null, proposalNumber: null },
      })
    }
    history.replace(`/workorders/t2/${workOrderID}`)
  } else {
    history.replace('/proposals')
  }
}

function* refreshCall() {
  yield put({
    type: actions.Refresh_Recieved,
  })
}

function* refreshReset() {
  yield put({
    type: actions.Refresh_reset_Recieved,
  })
}

function* sagaSendToApprovement({ id }) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(sendToApprovement, id)
  if (result !== null) {
    if (result.status === 1) {
      notification.success({ message: SAVE_200_MSG, description: result.message })
    } else {
      notification.error({ message: '', description: result.message })
    }
  }
  yield put({
    type: actions.SEND_TO_APPROVEMENT_RECIEVED,
    result,
  })
}

function* sagaApproveProposal({ id, approvedComment }) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(approveProposal, id, approvedComment)
  if (result !== null) {
    if (result.status === 1 && result.warning) {
      // PROTEC-951: approved by PROTEC although the budget is exceeded
      notification.warning({ message: SAVE_200_MSG, description: result.message, duration: 0 })
    } else if (result.status === 1) {
      notification.success({ message: SAVE_200_MSG, description: result.message })
    } else {
      notification.error({ message: '', description: result.message })
    }
  }
  yield put({
    type: actions.FETCH_PROPOSAL_PREVIEW,
    id,
  })
}

function* sagaRejectProposal({ id, rejectReason }) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(rejectProposal, id, rejectReason)
  if (result !== null) {
    if (result.status === 1) {
      notification.success({ message: SAVE_200_MSG, description: result.message })
    } else {
      notification.error({ message: '', description: result.message })
    }
  }
  yield put({
    type: actions.FETCH_PROPOSAL_PREVIEW,
    id,
  })
}

function* sagaCancelProposal({ id }) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(cancelProposal, id)
  if (result !== null) {
    if (result.status === 1) {
      notification.success({ message: SAVE_200_MSG, description: result.message })
    } else {
      notification.error({ message: '', description: result.message })
    }
  }
  yield put({
    type: actions.FETCH_PROPOSAL_PREVIEW,
    id,
  })
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.COPY_PROPOSAL_RESET, copyProposalReset),
    takeEvery(actions.COPY_PROPOSAL, copyProposal),

    takeEvery(actions.Refresh_reset, refreshReset),
    takeEvery(actions.Refresh, refreshCall),

    takeEvery(actions.RESET_PROPOSAL, resetPRoposal),

    takeEvery(actions.CREATE_PROPOSAL, createProposal),
    takeEvery(actions.CREATE_RESET_PROPOSAL, createResetProposal),

    takeEvery(actions.FETCH_PROPOSALS, fetchProposals),
    takeEvery(actions.FETCH_PROPOSAL, fetchProposalEdit),
    takeEvery(actions.FETCH_PROPOSAL_PREVIEW, fetchProposalEditForPreview),
    takeEvery(actions.SAVE_PROPOSAL, fetchProposalSave),
    takeEvery(actions.DELETE_PROPOSAL, fetchProposalDelete),
    takeEvery(actions.RE_FETCH_PROPOSALS, fetchProposalsRefresh),
    takeEvery(actions.FETCH_COST_VIEW, fetchCostView),

    takeEvery(actions.FETCH_PROPOSALS_FOR_APPROVEMENT, fetchProposalsForApprovement),
    takeEvery(actions.SEND_TO_APPROVEMENT, sagaSendToApprovement),
    takeEvery(actions.APPROVE_PROPOSAL, sagaApproveProposal),
    takeEvery(actions.REJECT_PROPOSAL, sagaRejectProposal),
    takeEvery(actions.CANCEL_PROPOSAL, sagaCancelProposal),
  ])
}
